import { Card, Typography } from "@mui/material";

export default function FeatureCard({ title }) {
  return (
    <Card sx={{ p: 3, height: "100%" }}>
      <Typography variant="h6">{title}</Typography>
      <Typography color="text.secondary" mt={1}>
        Enhances plant health and supports sustainable agriculture.
      </Typography>
    </Card>
  );
}
